const getCurrentAndPreviousCenturyPrefixes = (utcNow) => {
    const currentCenturyPrefix = Math.floor(new Date().getUTCFullYear() / 100)
        .toString()
        .padStart(2, '0');
    const previousCenturyPrefix = (Math.floor(new Date().getUTCFullYear() / 100) - 1)
        .toString()
        .padStart(2, '0');
    return [currentCenturyPrefix, previousCenturyPrefix];
};
const isValidBirthDate = (yearSuffix, month, day, allowableCenturyPrefixes) => {
    for (let i = 0; i < allowableCenturyPrefixes.length; i++) {
        const dateString = `${allowableCenturyPrefixes[i]}${yearSuffix}/${month}/${day}`;
        const date = new Date(dateString);
        if (!isNaN(date.getTime()) &&
            date.getFullYear().toString().slice(-2) === yearSuffix &&
            (date.getMonth() + 1).toString().padStart(2, '0') === month &&
            date.getDate().toString().padStart(2, '0') === day) {
            return true;
        }
    }
    return false;
};
function calculateLuhnCheckDigit(numberString) {
    const numberList = [];
    for (const number of numberString) {
        const integer = parseInt(number, 10);
        numberList.push(integer);
    }
    const modulo = numberList.length % 2;
    let sum = 0;
    for (let i = 0; i < numberList.length; i++) {
        let amountToAdd = numberList[i];
        if ((i + 1) % 2 === modulo) {
            amountToAdd *= 2;
            if (amountToAdd > 9) {
                amountToAdd -= 9;
            }
        }
        sum += amountToAdd;
    }
    let checkDigit = 10 - (sum % 10);
    checkDigit = checkDigit === 10 ? 0 : checkDigit;
    return checkDigit;
}
export const isValidSAIDNumber = (value) => {
    if ((value === null || value === void 0 ? void 0 : value.length) !== 13)
        return false;
    if (!/^\d{13}$/.test(value))
        return false;
    var dateYearSubString = value.slice(0, 2);
    var dateMonthSubString = value.slice(2, 4);
    var dateDaySubString = value.slice(4, 6);
    var allowableCenturyPrefixes = getCurrentAndPreviousCenturyPrefixes(new Date());
    if (!isValidBirthDate(dateYearSubString, dateMonthSubString, dateDaySubString, allowableCenturyPrefixes))
        return false;
    var citizenDigit = value[10];
    if (citizenDigit !== '0' && citizenDigit !== '1')
        return false;
    var luhnCheckDigit = calculateLuhnCheckDigit(value.substring(0, 12));
    return luhnCheckDigit.toString() === value[12];
};
export const getDateOfBirthFromSAIDNumber = (value, today = new Date()) => {
    if (!isValidSAIDNumber(value))
        return null;
    const id = value;
    const yearSuffix = parseInt(id.slice(0, 2), 10);
    const month = parseInt(id.slice(2, 4), 10);
    const day = parseInt(id.slice(4, 6), 10);
    const currentCenturyStart = Math.floor(today.getFullYear() / 100) * 100;
    let dateOfBirth = new Date(currentCenturyStart + yearSuffix, month - 1, day);
    if (dateOfBirth > today) {
        dateOfBirth = new Date(currentCenturyStart - 100 + yearSuffix, month - 1, day);
    }
    return dateOfBirth;
};
export const normalizePassportNumber = (value) => (value !== null && value !== void 0 ? value : '').replace(/\s/g, '').toUpperCase();
export const isValidPassportNumber = (value) => /^([A-Z]\d{7}|[A-Z]{2}\d{6}|[A-Z]\d{8}|\d{9})$/.test(normalizePassportNumber(value));
//# sourceMappingURL=id-validation.js.map